<template>
  <v-container class="wrapper d-flex flex-column" mt-8 mb-8>
    <div class="title">{{ $t("orders.title") }}</div>
    <div class="order-tableHeader">
      <div
        class="order-tableColTitle
        "
      >
        {{ $t("orders.tableColTitle1") }}
      </div>
      <div
        class="order-tableColTitle
        "
      >
        {{ $t("orders.tableColTitle2") }}
      </div>
      <div
        class="order-tableColTitle
        "
      >
        {{ $t("orders.tableColTitle3") }}
      </div>
      <div
        class="order-tableColTitle
        "
      >
        {{ $t("orders.tableColTitle4") }}
      </div>
      <div
        class="order-tableColTitle
        "
      >
        {{ $t("orders.tableColTitle5") }}
      </div>
    </div>
    <div v-if="loading" class="loadingWrapper">
      <v-progress-circular
        :size="40"
        :width="3"
        color="#787ff7"
        indeterminate
      ></v-progress-circular>
    </div>
    <empty-box v-else-if="list.length == 0" />
    <div v-else>
      <OrderInfo
        v-for="item in list"
        :info="{
          invoiceNumber: item.invoiceNumber,
          planName: item.planName,
          amount: item.amount,
          quantity: item.quantity,
          createdAt: item.createdAt,
          paidAt: item.paidAt,
          status: item.status,
          idToken: item.idToken,
          url: item.url,
          client_key: client_key,
        }"
        :key="`${item.invoiceNumber}-${item.paidAmount}`"
        ><slot
      /></OrderInfo>
    </div>

    <v-row v-if="list.length != 0" class="mt-auto">
      <v-col cols="12" align-self="end" class="d-flex justify-end">
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="6"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          color="#787ff7"
          circle
          @input="nextPage"
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Vue from "vue";
import { format } from "date-fns";
import { mapActions } from "vuex";
import OrderInfo from "../components/OrderInfo";
import {
  InvoiceListRequest,
  InvoiceChangeRequest,
  ClientKeyRequest,
} from "../invoice_pb";
import { InvoiceInfoClient } from "../invoice_grpc_web_pb";
import EmptyBox from "../components/EmptyBox.vue";
export default {
  name: "Orders",
  components: { OrderInfo, EmptyBox },
  data: () => ({
    dialog: false,
    list: [],
    downloading: true,
    playing: null,
    token: null,
    count: 0,
    page: 1,
    pageCount: 0,
    itemsPerPage: 8,
    loading: true,
    client_key: "",
  }),
  computed: {
    getToken: function() {
      return this.$cookie.get("token");
    },
  },
  created() {
    this.client = new InvoiceInfoClient(
      process.env.VUE_APP_GRPC_URL,
      null,
      null
    );
  },
  mounted() {
    this.getList();
    this.checkUrl();
  },
  methods: {
    ...mapActions([
      "showErrorMessage",
      "showWarningMessage",
      "checkError",
      "showBuySuccessMessage",
    ]),
    checkUrl() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.has("totalPrice", "quantity", "userBalance")) {
        const totalPrice = urlParams.get("totalPrice");
        const quantity = urlParams.get("quantity");
        const userBalance = urlParams.get("userBalance");
        this.showBuySuccessMessage({
          message: this.$t("plan.successPrice", [
            totalPrice,
            quantity,
            userBalance,
          ]),
          timeout: 9999,
        });
      }
    },
    getList() {
      this.loading = true;
      let params = new InvoiceListRequest();
      params.setPage(this.page);
      params.setItemPerPage(this.itemsPerPage);
      this.client.getInvoiceList(
        params,
        {
          token: this.getToken,
        },
        (err, response) => {
          if (err) {
            console.log(err);
          } else {
            let data = response.toObject();
            let count = data.count;
            this.list = data.listList;
            this.pageCount = Math.ceil(count / this.itemsPerPage);
            this.client_key = data.clientKey;
            this.getPaymentStatus();
            this.loading = false;
          }
        }
      );
    },
    async getPaymentStatus() {
      let params = new InvoiceChangeRequest();
      params.setClientKey(this.client_key);
      let call = this.client.getInvoiceChange(params, {
        token: this.getToken,
      });
      call.on("data", (response) => {
        const data = response.toObject();
        if (data.status == "TIMEOUT") {
          this.getPaymentStatus();
        } else {
          this.updateList(data);
        }
      });
      call.on("end", () => {
        // call.end();
        console.log("end");
      });
      call.on("error", (response) => {
        // call.end();
        console.log("error", response);
      });
    },
    updateList(data) {
      let currentList = this.list;
      currentList.forEach((value, index) => {
        if (data.oldInvoiceNumber === value.invoiceNumber) {
          Vue.set(this.list, index, data.invoice);
          return;
        }
      });
    },
    // checkStatusList(list){
    //   let waitList = [];
    //   list.map(value => {
    //     if(value.status == 0){
    //      waitList.push(value.invoiceNumber);
    //     }
    //   })
    //   if(waitList.length > 0){
    //     this.getPaymentStatus(waitList)
    //   }
    // },
    closeKey() {
      let params = new ClientKeyRequest();
      params.setClientKey(this.client_key);
      this.client.closeInvoiceChange(
        params,
        { token: this.getToken },
        (err) => {
          if (err) {
            console.log(err);
          } else {
            console.log("close");
          }
        }
      );
    },
    nextPage(page) {
      this.page = page;
      // this.loading = true;
      this.closeKey();
      this.getList();
    },
    getFormatDate(date) {
      var currentDate = new Date(date);
      currentDate.setHours(currentDate.getHours());
      return format(currentDate, "yyyy/MM/dd HH:mm");
    },
    getPageCount(characterLength) {
      return Math.ceil(characterLength / 3750);
    },
    toDateTime(secs) {
      var t = new Date(1970, 0, 1); // Epoch
      t.setSeconds(secs);
      return t;
    },
  },
  destroyed() {
    this.closeKey();
  },
};
</script>
<style scoped>
.wrapper {
  display: flex;

  /* align-items: center; */
  max-width: 1344px;
  min-height: 80%;
  border-radius: 15px;
  padding-bottom: 30px;
}

@media screen and (max-width: 1343px) {
  .wrapper {
    width: 90%;
  }
}
.loadingWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 520px;
}

.title {
  font-weight: 700;
  text-align: left;
  line-height: 23px;
  font-size: 20px;
  color: #000000;
  margin-bottom: 16px;
}

.position {
  text-align: right;
}

.fillBtn {
  background-color: #787ff7 !important;
  text-transform: initial;
  color: #ffffff;
  outline: none;
}

.outlineBtn {
  color: #787ff7;
  text-transform: initial;
  outline: none;
  z-index: 1;
}

.snackBar1 {
  color: green !important;
}

.circle {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50px;
}

.order-tableHeader {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 5px;
}

.order-tableColTitle {
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  text-align: left;
}

.order-textStyle {
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  text-align: left;
}

.order-smallDesign {
  display: none;
}

@media screen and (max-width: 768px) {
  .order-tableColTitle {
    display: none;
  }

  .order-smallDesign {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: #767676;
    text-align: left;
    border-bottom: 1px solid #e8ebed;
  }

  .order-tableHeader {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
